import { MenuItem } from "@headlessui/react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

/** Action-menu row for Complete → Reopen VQQ (modal stays outside MenuItems). */
export default function ReopenVqqMenuItem({ onOpen }) {
  return (
    <MenuItem>
      {({ active }) => (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onOpen?.();
          }}
          className={`flex w-full items-center space-x-2 text-left ${
            active ? "bg-gray-100 text-gray-900" : "text-gray-700"
          } block px-4 py-2 text-sm`}
        >
          <ArrowPathIcon className="w-[16px] h-[16px]" />
          <span>Reopen VQQ</span>
        </button>
      )}
    </MenuItem>
  );
}
